import { realtimeDb, firestoreDb, firebaseAuth } from '../config/constants'
import firebase from 'firebase';
import log from '../helpers/logger'

export function getPublisherList(){

  let dataList = []
  return firestoreDb.collection("publisher").orderBy("date_created", "desc").get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function updatePublisher (id, publisher) {
  return firestoreDb.collection("publisher").doc(id).update({
    publisher_uuid: publisher.publisher_uuid,
    owner_id: publisher.owner_id,
    tag: publisher.tag,
    title: publisher.title,
    description: publisher.description,
    date_created: publisher.date_created,
    status: publisher.status
    }).then(() => publisher)
}

export function getPublisher (id) {

  return firestoreDb.collection("publisher").doc(id).get().then(function(doc) {
    if (doc.exists) {
        return doc.data();
    } else {
        return null
    }
  });

}

export function deletePublisher (id) {
  let publisher = null
  return firestoreDb.collection("publisher").doc(id).update({
    status: 'D'
    }).then(() => publisher)
}

export function createPublisher (publisher) {
  //setup date_created from firebase server.
  publisher.date_created = firebase.firestore.FieldValue.serverTimestamp()

  return firestoreDb.collection("publisher").add({
    publisher_uuid: publisher.publisher_uuid,
    owner_id: publisher.owner_id,
    tag: publisher.tag,
    title: publisher.title,
    description: publisher.description,
    date_created: publisher.date_created,
    status: publisher.status
    }).then(() => publisher)

}



// WEBPACK FOOTER //
// ./src/services/PublisherService.js